export const MAX_QUIZ_COUNT = 20;

export const IMAGE_UPLOAD_CONSTANTS = {
  ALLOWED_IMAGE_EXTENSIONS: ['jpg', 'jpeg', 'png', 'webp'],
  MAX_IMAGE_DIMENSION: 2048,
  MAX_MB_SIZE: 3,
  MAX_IMAGE_COUNT: 1,
};
